import { render, staticRenderFns } from "./MyDashboardSummary.vue?vue&type=template&id=6f77489b"
import script from "./MyDashboardSummary.vue?vue&type=script&lang=ts"
export * from "./MyDashboardSummary.vue?vue&type=script&lang=ts"
import style0 from "./MyDashboardSummary.vue?vue&type=style&index=0&id=6f77489b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports